if (!customElements.get('component-stitching')) {
    class Stitching extends HTMLElement {
        constructor() {
            super();
            this.selectors = {
                container: '[data-stitching-product-replace]',
                stitchEventClick: '[stitch-event-click]',
                sectionId: 'stitching-section-id',
                atbContainer: '[data-stitching-atb-replace]',
                galleryContainer: '[data-stitching-gallery-replace]',
                productTitleContainer: '[data-stitching-title-replace]',
                productPriceContainer: '[data-stitching-price-replace]',
                productStitchingContainer: '[data-stitching-stitching-replace]',
                productDescription: '.product-description',
                productRecharge: '.recharge-subscription-widget',
                productQuantityContainer: '[data-stitching-quantity-replace]',
                productBadgesContainer: '[data-stitching-product-badges-replace]',
                productStyleContainer: '[data-stitching-product-style-replace]'


            }

        }

        connectedCallback() {
            this.init();
        }

        init() {
            this.container = document.querySelector(this.selectors.container);


            if (!this.container) {
                return;
            }


            this.sectionId = this.getAttribute(this.selectors.sectionId) || '';

            this.addListeners();
        }

        addListeners() {

            this.customDelegate(
                "click",
                this.selectors.stitchEventClick,
                this.handleClick.bind(this)
            )
        }

        handleClick(e, element) {
            e.preventDefault();
            this.stitchProductId = element.getAttribute('data-stitch-product-id');
            this.stitchVariantId = element.getAttribute('data-stitch-variant-id');
            this.stitchRequestUrl = element.getAttribute('data-stitch-request-url');
            this.stitchTemplateName = element.getAttribute('data-stitch-template-name');
            this.stitchingReloadPage = element.getAttribute('data-stitching-reload-page');

            if (!this.stitchProductId || !this.stitchVariantId || !this.stitchRequestUrl) {
                return;
            }

            if (this.stitchingReloadPage === 'true') {
                window.location.href = this.stitchRequestUrl;
                return;
            }
            else {
                this.fetchStitchingData();
            }
        }

        async fetchStitchingData() {

            try {
                const response = await fetch(this.stitchRequestUrl + `&view=${this.stitchTemplateName}`);
                const data = await response.text();
                const parsed = new DOMParser().parseFromString(data, 'text/html');

                const parsedAtbContainer = parsed.querySelector(this.selectors.atbContainer);
                const parsedGalleryContainer = parsed.querySelector(this.selectors.galleryContainer);
                const parsedProductTitleContainer = parsed.querySelector(this.selectors.productTitleContainer);
                const parsedProductPriceContainer = parsed.querySelector(this.selectors.productPriceContainer);
                const parsedProductStitchingContainer = parsed.querySelector(this.selectors.productStitchingContainer);
                const parsedProductDescription = parsed.querySelector(this.selectors.productDescription);
                const parsedProductRecharge = parsed.querySelector(this.selectors.productRecharge);
                const parsedProductQuantityContainer = parsed.querySelector(this.selectors.productQuantityContainer);
                const parsedProductBadgesContainer = parsed.querySelector(this.selectors.productBadgesContainer);
                const parsedProductStyleContainer = parsed.querySelector(this.selectors.productStyleContainer);



                this.replaceState();

                this.replaceGallery(parsedGalleryContainer);

                this.replaceProductTitle(parsedProductTitleContainer);
                this.replaceProductPrice(parsedProductPriceContainer);
                this.replaceProductStitching(parsedProductStitchingContainer);
                this.replaceProductDescription(parsedProductDescription);
                this.replaceProductRecharge(parsedProductRecharge);
                this.replaceProductQuantity(parsedProductQuantityContainer);
                this.replaceProductBadges(parsedProductBadgesContainer);
                this.replaceProductStyle(parsedProductStyleContainer);
                this.replaceAtb(parsedAtbContainer);



            } catch (error) {
                console.error('Error fetching stitching data:', error);
            }


        }

        replaceProductStyle(parsedProductStyleContainer) {

            this.productStyleContainer = document.querySelector(this.selectors.productStyleContainer);
            if (!this.productStyleContainer) {
                console.error('Product style container not found');
                return;
            }
            this.productStyleContainer.innerHTML = parsedProductStyleContainer.innerHTML;
        }

        replaceAtb(parsedAtbContainer) {
            this.atbContainer = document.querySelector(this.selectors.atbContainer);
            if (!this.atbContainer) {
                console.error('Atb container not found');
                return;
            }
            this.atbContainer.innerHTML = parsedAtbContainer.innerHTML;
        }

        replaceGallery(parsedGalleryContainer) {
            this.galleryContainer = document.querySelector(this.selectors.galleryContainer);
            if (!this.galleryContainer) {
                console.error('Gallery container not found');
                return;
            }
            this.galleryContainer.innerHTML = parsedGalleryContainer.innerHTML;
        }

        replaceProductInfo(parsedProductInfoContainer) {
            this.productInfoContainer = document.querySelector(this.selectors.productInfoContainer);

            if (!this.productInfoContainer) {
                console.error('Product info container not found');
                return;
            }
            this.productInfoContainer.innerHTML = parsedProductInfoContainer.innerHTML;
        }

        replaceProductTitle(parsedProductTitleContainer) {
            this.productTitleContainer = document.querySelector(this.selectors.productTitleContainer);
            if (!this.productTitleContainer) {
                console.error('Product title container not found');
                return;
            }
            this.productTitleContainer.innerHTML = parsedProductTitleContainer.innerHTML;
        }

        replaceProductPrice(parsedProductPriceContainer) {
            this.productPriceContainer = document.querySelector(this.selectors.productPriceContainer);
            if (!this.productPriceContainer) {
                console.error('Product price container not found');
                return;
            }
            this.productPriceContainer.innerHTML = parsedProductPriceContainer.innerHTML;
        }

        replaceProductStitching(parsedProductStitchingContainer) {
            this.productStitchingContainer = document.querySelector(this.selectors.productStitchingContainer);
            if (!this.productStitchingContainer) {
                console.error('Product stitching container not found');
                return;
            }
            this.productStitchingContainer.innerHTML = parsedProductStitchingContainer.innerHTML;
        }

        replaceProductDescription(parsedProductDescription) {
            this.productDescription = document.querySelector(this.selectors.productDescription);
            if (!this.productDescription) {
                console.error('Product description not found');
                return;
            }
            this.productDescription.innerHTML = parsedProductDescription.innerHTML;
        }

        replaceProductRecharge(parsedProductRecharge) {
            this.productRecharge = document.querySelector(this.selectors.productRecharge);
            if (!this.productRecharge) {
                console.error('Product recharge not found');
                return;
            }
            this.productRecharge.innerHTML = parsedProductRecharge.innerHTML;

            const scripts = parsedProductRecharge.querySelectorAll("script");

            scripts.forEach(oldScript => {
                const newScript = document.createElement("script");

                if (oldScript.src) {
                    newScript.src = oldScript.src;
                    newScript.type = oldScript.type || "text/javascript";
                } else {
                    newScript.textContent = oldScript.textContent;
                    newScript.type = oldScript.type || "text/javascript";
                }

                this.productRecharge.appendChild(newScript);
            })
        }

        replaceProductQuantity(parsedProductQuantityContainer) {
            this.productQuantityContainer = document.querySelector(this.selectors.productQuantityContainer);
            if (!this.productQuantityContainer) {
                console.error('Product quantity container not found');
                return;
            }
            this.productQuantityContainer.innerHTML = parsedProductQuantityContainer.innerHTML;
        }

        replaceProductBadges(parsedProductBadgesContainer) {
            this.productBadgesContainer = document.querySelector(this.selectors.productBadgesContainer);
            if (!this.productBadgesContainer) {
                console.error('Product badges container not found');
                return;
            }
            this.productBadgesContainer.innerHTML = parsedProductBadgesContainer.innerHTML;
        }

        replaceState() {
            history.replaceState({}, "handle", this.stitchRequestUrl);
        }

        customDelegate(eventName, elementSelector, handler) {
            this.addEventListener(eventName, (e) => {
                const element = e.target.closest(elementSelector);

                if (element) {
                    handler.call(element, e, element);
                }
            }, false);
        };


    }

    customElements.define('component-stitching', Stitching);
}
